import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime.js';
import cn from 'classnames';
import { SmallText } from '../../../Typography/Typography.js';
import { ReactComponent as SvgAutoTheme } from '../../../../media/images/auto-theme.svg.js';
import { ThemeTitle } from '../../types.js';
import { Line } from '../Line/Line.js';
import { isAuto, isDark } from '../../../../utils/theme.js';
import styles from './ThemeView.module.css.js';

var ThemeView = function ThemeView(_ref) {
  var theme = _ref.theme;
  var lines = _toConsumableArray(Array(LINE_COUNT).keys());
  return jsxs(Fragment, {
    children: [isAuto(theme) ? jsx(SvgAutoTheme, {
      className: styles.autoTheme
    }) : jsxs("span", {
      className: cn(styles.container, _defineProperty({}, styles.darkContainer, isDark(theme))),
      children: [jsx(Line, {
        width: 83,
        isDark: isDark(theme)
      }), jsx("span", {
        className: styles.circle
      }), lines.map(function (line) {
        return jsx(Line, {
          isDark: isDark(theme)
        }, line);
      }), jsx(Line, {
        width: 17,
        height: 7,
        isBlue: true
      })]
    }), jsx(SmallText, {
      className: styles.themeName,
      children: ThemeTitle[theme]
    })]
  });
};
var LINE_COUNT = 4;

export { ThemeView };
